export interface MatomoEvent {
  categorie: string;
  action: string;
  nom: string;
}

// Type a utiliser seulement pour le "satisfies" sinon le type MatomoEventKey ne fonctionnera plus
export type MatomoEventMap = Record<string, MatomoEvent>;

const matomoEventMap = {
  ACCUEIL_ACCEDER_FICHE_PROJET: {
    categorie: 'Accueil',
    action: 'Acceder-Fiche-Projet',
    nom: 'Accueil-Acceder-Fiche-Projet-${elementCliquable}',
  },
  ACCUEIL_ACCEDER_LISTE_OFFRES: {
    categorie: 'Accueil',
    action: 'Acceder-Liste-Offres',
    nom: 'Accueil-Acceder-Liste-Offres-${rubrique}',
  },
  BANNIERE_MARKETING_ACCUEIL_CLIQUER: {
    categorie: 'Banniere-Marketing-Accueil',
    action: 'Cliquer',
    nom: 'Banniere-Marketing-Accueil-Cliquer',
  },
  BANNIERE_MARKETING_ACCUEIL_FERMER: {
    categorie: 'Banniere-Marketing-Accueil',
    action: 'Fermer',
    nom: 'Banniere-Marketing-Accueil-Fermer',
  },
  BANNIERE_MARKETING_OFFRES_CLIQUER: {
    categorie: 'Banniere-Marketing-Offres',
    action: 'Cliquer',
    nom: 'Banniere-Marketing-Offres-Cliquer-${rubrique}',
  },
  CONFORMITE_CLIQUER_LIEN_CARTE: {
    categorie: 'Conformite',
    action: 'Cliquer-Lien-Carte',
    nom: 'Conformite-Cliquer-Lien-Carte-${titre}',
  },
  CONFORMITE_CLIQUER_LIEN_INTRODUCTION: {
    categorie: 'Conformite',
    action: 'Cliquer-Lien-Introduction',
    nom: 'Conformite-Cliquer-Lien-Introduction',
  },
  CONFORMITE_CLIQUER_ONGLET: {
    categorie: 'Conformite',
    action: 'Cliquer-Onglet',
    nom: 'Conformite-Cliquer-Onglet-${titre}',
  },
  CONFORMITE_TELECHARGER_DOCUMENT_CARTE: {
    categorie: 'Conformite',
    action: 'Telecharger-Document-Carte',
    nom: 'Conformite-Telecharger-Document-Carte-${titre}',
  },
  CONFORMITE_TELECHARGER_DOCUMENT_ONGLET: {
    categorie: 'Conformite',
    action: 'Telecharger-Document-Onglet',
    nom: 'Conformite-Telecharger-Document-Onglet-${titre}',
  },
  CONNEXION_ACCEDER_CONNECT: {
    categorie: 'Connexion',
    action: 'Acceder-Connect',
    nom: 'Connexion-Acceder-Connect-${codeDistributeur}',
  },
  CONTRAT_ASSURES_ACCEDER_MODALE_CARTE_TIERS_PAYANT: {
    categorie: 'Contrat-Assures',
    action: 'Acceder-Modale-Carte-Tiers-Payant',
    nom: 'Contrat-Assures-Acceder-Modale-Carte-Tiers-Payant',
  },
  CONTRAT_ASSURES_ACCEDER_MODALE_DETAIL_ASSURE: {
    categorie: 'Contrat-Assures',
    action: 'Acceder-Modale-Detail-Assure',
    nom: 'Contrat-Assures-Acceder-Modale-Detail-Assure',
  },
  CONTRAT_ASSURES_ACCEDER_MODALE_IDENTIFIANT_CONNEXION: {
    categorie: 'Contrat-Assures',
    action: 'Acceder-Modale-Identifiant-Connexion',
    nom: 'Contrat-Assures-Acceder-Modale-Identifiant-Connexion',
  },
  CONTRAT_ASSURES_ACCEDER_MODALE_MOT_DE_PASSE_OUBLIE: {
    categorie: 'Contrat-Assures',
    action: 'Acceder-Modale-Mot-De-Passe-Oublie',
    nom: 'Contrat-Assures-Acceder-Modale-Mot-De-Passe-Oublie',
  },
  CONTRAT_ASSURES_ENVOYER_CARTE_TIERS_PAYANT: {
    categorie: 'Contrat-Assures',
    action: 'Envoyer-Carte-Tiers-Payant',
    nom: 'Contrat-Assures-Envoyer-Carte-Tiers-Payant',
  },
  CONTRAT_ASSURES_ENVOYER_IDENTIFIANT_CONNEXION: {
    categorie: 'Contrat-Assures',
    action: 'Envoyer-Identifiant-Connexion',
    nom: 'Contrat-Assures-Envoyer-Identifiant-Connexion',
  },
  CONTRAT_ASSURES_ENVOYER_MOT_DE_PASSE_OUBLIE: {
    categorie: 'Contrat-Assures',
    action: 'Envoyer-Mot-De-Passe-Oublie',
    nom: 'Contrat-Assures-Envoyer-Mot-De-Passe-Oublie',
  },
  DETAIL_ACTUALITE_ACCEDER_LISTE_ACTUALITES: {
    categorie: 'Detail-Actualite',
    action: 'Acceder-Liste-Actualites',
    nom: 'Detail-Actualite-Acceder-Liste-Actualites',
  },
  DETAIL_ACTUALITE_CONSULTER_ACTUALITE_LIEE: {
    categorie: 'Detail-Actualite',
    action: 'Consulter-Actualite-Liee',
    nom: 'Detail-Actualite-Consulter-Actualite-Liee',
  },
  DOCUMENTATION_TELECHARGER: {
    categorie: 'Documentation',
    action: 'Telecharger',
    nom: 'Documentation-Telecharger-${titre}',
  },
  DOCUMENTATION_TELECHARGER_MULTIPLE: {
    categorie: 'Documentation',
    action: 'Telecharger-Multiple',
    nom: 'Documentation-Telecharger-Multiple',
  },
  FICHE_CLIENT_COLLECTIF_ACCEDER_MODALE_IDENTIFIANT_CONNEXION: {
    categorie: 'Fiche-Client-Collectif',
    action: 'Acceder-Modale-Identifiant-Connexion',
    nom: 'Fiche-Client-Collectif-Acceder-Modale-Identifiant-Connexion',
  },
  FICHE_CLIENT_COLLECTIF_ACCEDER_MODALE_MOT_DE_PASSE_PERDU: {
    categorie: 'Fiche-Client-Collectif',
    action: 'Acceder-Modale-Mot-De-Passe-Perdu',
    nom: 'Fiche-Client-Collectif-Acceder-Modale-Mot-De-Passe-Perdu',
  },
  FICHE_CLIENT_COLLECTIF_DEPLIER_ENVOI_ACCES_CLIENT: {
    categorie: 'Fiche-Client-Collectif',
    action: 'Deplier-Envoi-Acces-Client',
    nom: 'Fiche-Client-Collectif-Deplier-Envoi-Acces-Client',
  },
  FICHE_CLIENT_COLLECTIF_ENVOYER_IDENTIFIANT_CONNEXION: {
    categorie: 'Fiche-Client-Collectif',
    action: 'Envoyer-Identifiant-Connexion',
    nom: 'Fiche-Client-Collectif-Envoyer-Identifiant-Connexion',
  },
  FICHE_CLIENT_COLLECTIF_ENVOYER_MOT_DE_PASSE_PERDU: {
    categorie: 'Fiche-Client-Collectif',
    action: 'Envoyer-Mot-De-Passe-Perdu',
    nom: 'Fiche-Client-Collectif-Envoyer-Mot-De-Passe-Perdu',
  },
  FICHE_CLIENT_INDIVIDUEL_ACCEDER_MODALE_CARTE_TIERS_PAYANT: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Acceder-Modale-Carte-Tiers-Payant',
    nom: 'Fiche-Client-Individuel-Acceder-Modale-Carte-Tiers-Payant',
  },
  FICHE_CLIENT_INDIVIDUEL_ACCEDER_MODALE_IDENTIFIANT_CONNEXION: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Acceder-Modale-Identifiant-Connexion',
    nom: 'Fiche-Client-Individuel-Acceder-Modale-Identifiant-Connexion',
  },
  FICHE_CLIENT_INDIVIDUEL_ACCEDER_MODALE_MOT_DE_PASSE_PERDU: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Acceder-Modale-Mot-De-Passe-Perdu',
    nom: 'Fiche-Client-Individuel-Acceder-Modale-Mot-De-Passe-Perdu',
  },
  FICHE_CLIENT_INDIVIDUEL_DEPLIER_ENVOI_ACCES_CLIENT: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Deplier-Envoi-Acces-Client',
    nom: 'Fiche-Client-Individuel-Deplier-Envoi-Acces-Client',
  },
  FICHE_CLIENT_INDIVIDUEL_ENVOYER_CARTE_TIERS_PAYANT: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Envoyer-Carte-Tiers-Payant',
    nom: 'Fiche-Client-Individuel-Envoyer-Carte-Tiers-Payant',
  },
  FICHE_CLIENT_INDIVIDUEL_ENVOYER_IDENTIFIANT_CONNEXION: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Envoyer-Identifiant-Connexion',
    nom: 'Fiche-Client-Individuel-Envoyer-Identifiant-Connexion',
  },
  FICHE_CLIENT_INDIVIDUEL_ENVOYER_MOT_DE_PASSE_PERDU: {
    categorie: 'Fiche-Client-Individuel',
    action: 'Envoyer-Mot-De-Passe-Perdu',
    nom: 'Fiche-Client-Individuel-Envoyer-Mot-De-Passe-Perdu',
  },
  GESTION_COMPTE_ACCEDER_ONGLET_GESTION_COMPTE: {
    categorie: 'Gestion-Compte',
    action: 'Acceder-Onglet-Gestion-Compte',
    nom: 'Gestion-Compte-Acceder-Onglet-Gestion-Compte',
  },
  GESTION_COMPTE_ACCEDER_ONGLET_GESTION_UTILISATEURS: {
    categorie: 'Gestion-Compte',
    action: 'Acceder-Onglet-Gestion-Utilisateurs',
    nom: 'Gestion-Compte-Acceder-Onglet-Gestion-Utilisateurs',
  },
  GESTION_COMPTE_ACCEDER_ONGLET_INFORMATIONS_PARTENAIRE: {
    categorie: 'Gestion-Compte',
    action: 'Acceder-Onglet-Informations-Partenaire',
    nom: 'Gestion-Compte-Acceder-Onglet-Informations-Partenaire',
  },
  GESTION_COMPTE_ACCEDER_ONGLET_MES_NOTIFICATIONS: {
    categorie: 'Gestion-Compte',
    action: 'Acceder-Onglet-Mes-Notifications',
    nom: 'Gestion-Compte-Acceder-Onglet-Mes-Notifications',
  },
  HEADER_ACCEDER_ACCUEIL: {
    categorie: 'Header',
    action: 'Acceder-Accueil',
    nom: 'Header-Acceder-Accueil',
  },
  HEADER_ACTUALITES_ACCEDER_LISTE_ACTUALITES: {
    categorie: 'Header-Actualites',
    action: 'Acceder-Liste-Actualites',
    nom: 'Header-Actualites-Acceder-Liste-Actualites',
  },
  HEADER_ACTUALITES_CONSULTER_DETAIL_ACTUALITE: {
    categorie: 'Header-Actualites',
    action: 'Consulter-Detail-Actualite',
    nom: 'Header-Actualites-Consulter-Detail-Actualite',
  },
  HEADER_DEPLIER_ACTUALITES: {
    categorie: 'Header',
    action: 'Deplier-Actualites',
    nom: 'Header-Deplier-Actualites',
  },
  HEADER_DEPLIER_NOTIFICATIONS: {
    categorie: 'Header',
    action: 'Deplier-Notifications',
    nom: 'Header-Deplier-Notifications',
  },
  HEADER_DEPLIER_PROFIL: {
    categorie: 'Header',
    action: 'Deplier-Profil',
    nom: 'Header-Deplier-Profil',
  },
  HEADER_MOTEUR_RECHERCHE_ACCEDER_FICHE_CLIENT_COLLECTIF: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Acceder-Fiche-Client-Collectif',
    nom: 'Header-Moteur-Recherche-Acceder-Fiche-Client-Collectif-${nomPage}',
  },
  HEADER_MOTEUR_RECHERCHE_ACCEDER_FICHE_CLIENT_INDIVIDUEL: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Acceder-Fiche-Client-Individuel',
    nom: 'Header-Moteur-Recherche-Acceder-Fiche-Client-Individuel-${nomPage}',
  },
  HEADER_MOTEUR_RECHERCHE_ACCEDER_FICHE_PROJET: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Acceder-Fiche-Projet',
    nom: 'Header-Moteur-Recherche-Acceder-Fiche-Projet-${nomPage}',
  },
  HEADER_MOTEUR_RECHERCHE_ACCEDER_LISTE_CLIENT_COLLECTIF: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Acceder-Liste-Client-Collectif',
    nom: 'Header-Moteur-Recherche-Acceder-Liste-Client-Collectif-${nomPage}',
  },
  HEADER_MOTEUR_RECHERCHE_ACCEDER_LISTE_CLIENT_INDIVIDUEL: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Acceder-Liste-Client-Individuel',
    nom: 'Header-Moteur-Recherche-Acceder-Liste-Client-Individuel-${nomPage}',
  },
  HEADER_MOTEUR_RECHERCHE_ACCEDER_LISTE_PROJET: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Acceder-Liste-Projet',
    nom: 'Header-Moteur-Recherche-Acceder-Liste-Projet-${nomPage}',
  },
  HEADER_MOTEUR_RECHERCHE_EFFECTUER_RECHERCHE: {
    categorie: 'Header-Moteur-Recherche',
    action: 'Effectuer-Recherche',
    nom: 'Header-Moteur-Recherche-Effectuer-Recherche-${nomPage}',
  },
  HEADER_NOTIFICATIONS_CONSULTER_DETAIL_IMPAYE: {
    categorie: 'Header-Notifications',
    action: 'Consulter-Detail-Impaye',
    nom: 'Header-Notifications-Consulter-Detail-Impaye',
  },
  HEADER_NOTIFICATIONS_MARQUER_COMME_LU: {
    categorie: 'Header-Notifications',
    action: 'Marquer-Comme-Lu',
    nom: 'Header-Notifications-Marquer-Comme-Lu',
  },
  HEADER_PROFIL_ACCEDER_CHANGER_MOT_DE_PASSE: {
    categorie: 'Header-Profil',
    action: 'Acceder-Changer-Mot-De-Passe',
    nom: 'Header-Profil-Acceder-Changer-Mot-De-Passe',
  },
  HEADER_PROFIL_ACCEDER_GESTION_COMPTE: {
    categorie: 'Header-Profil',
    action: 'Acceder-Gestion-Compte',
    nom: 'Header-Profil-Acceder-Gestion-Compte',
  },
  HEADER_PROFIL_ACCEDER_GESTION_UTILISATEURS: {
    categorie: 'Header-Profil',
    action: 'Acceder-Gestion-Utilisateurs',
    nom: 'Header-Profil-Acceder-Gestion-Utilisateurs',
  },
  HEADER_PROFIL_ACCEDER_INFORMATIONS_PARTENAIRE: {
    categorie: 'Header-Profil',
    action: 'Acceder-Informations-Partenaire',
    nom: 'Header-Profil-Acceder-Informations-Partenaire',
  },
  HEADER_PROFIL_ACCEDER_PREFERENCES_DE_NOTIFICATIONS: {
    categorie: 'Header-Profil',
    action: 'Acceder-Preferences-De-Notifications',
    nom: 'Header-Profil-Acceder-Preferences-De-Notifications',
  },
  HEADER_PROFIL_SE_DECONNECTER: {
    categorie: 'Header-Profil',
    action: 'Se-deconnecter',
    nom: 'Header-Profil-Se-deconnecter',
  },
  INFORMATIONS_PARTENAIRE_ACCEDER_PAGE_CONTACT: {
    categorie: 'Informations-Partenaire',
    action: 'Acceder-Page-Contact',
    nom: 'Informations-Partenaire-Acceder-Page-Contact',
  },
  LISTE_ACTUALITES_CONSULTER_DETAIL_ACTUALITE: {
    categorie: 'Liste-Actualites',
    action: 'Consulter-Detail-Actualite',
    nom: 'Liste-Actualites-Consulter-Detail-Actualite',
  },
  LISTE_CLIENTS_ACCEDER_FICHE_CLIENT: {
    categorie: 'Liste-Clients',
    action: 'Acceder-Fiche-Client',
    nom: 'Liste-Clients-Acceder-Fiche-Client-${portefeuille}-${elementCliquable}',
  },
  LISTE_CLIENTS_ACCEDER_MODALE_CARTE_TIERS_PAYANT: {
    categorie: 'Liste-Clients',
    action: 'Acceder-Modale-Carte-Tiers-Payant',
    nom: 'Liste-Clients-Acceder-Modale-Carte-Tiers-Payant',
  },
  LISTE_CLIENTS_CONSULTER_OPTIONS_TELECHARGEMENT: {
    categorie: 'Liste-Clients',
    action: 'Consulter-Options-Telechargement',
    nom: 'Liste-Clients-Consulter-Options-Telechargement-${portefeuille}',
  },
  LISTE_CLIENTS_ENVOYER_CARTE_TIERS_PAYANT: {
    categorie: 'Liste-Clients',
    action: 'Envoyer-Carte-Tiers-Payant',
    nom: 'Liste-Clients-Envoyer-Carte-Tiers-Payant',
  },
  LISTE_CLIENTS_TELECHARGER_ATTESTATIONS_MADELIN: {
    categorie: 'Liste-Clients',
    action: 'Telecharger-Attestations-Madelin',
    nom: 'Liste-Clients-Telecharger-Attestations-Madelin-${portefeuille}',
  },
  LISTE_CLIENTS_TELECHARGER_PORTEFEUILLE_CLIENT: {
    categorie: 'Liste-Clients',
    action: 'Telecharger-Portefeuille-Client',
    nom: 'Liste-Clients-Telecharger-Portefeuille-Client-${portefeuille}',
  },
  LISTE_CLIENTS_TELECHARGER_TOUTES_LES_ATTESTATIONS_MADELIN: {
    categorie: 'Liste-Clients',
    action: 'Telecharger-Toutes-Les-Attestations-Madelin',
    nom: 'Liste-Clients-Telecharger-Toutes-Les-Attestations-Madelin',
  },
  LISTE_OFFRES_ACCEDER_DEVENIR_PARTENAIRE: {
    categorie: 'Liste-Offres',
    action: 'Acceder-Devenir-Partenaire',
    nom: 'Liste-Offres-Acceder-Devenir-Partenaire-${partenaire}-${rubrique}',
  },
  LISTE_OFFRES_ACCEDER_OAV: {
    categorie: 'Liste-Offres',
    action: 'Acceder-Oav',
    nom: 'Liste-Offres-Acceder-Oav-${rubrique}-${offre}-${labelCliquable}',
  },
  LISTE_OFFRES_ACCEDER_PLATEFORME: {
    categorie: 'Liste-Offres',
    action: 'Acceder-Plateforme',
    nom: 'Liste-Offres-Acceder-Plateforme-${partenaire}-${rubrique}',
  },
  LISTE_OFFRES_DEPLIER_CONDITIONS_POINTS_FORTS: {
    categorie: 'Liste-Offres',
    action: 'Deplier-Conditions-Points-Forts',
    nom: 'Liste-Offres-Deplier-Conditions-Points-Forts-${rubrique}-${offre}',
  },
  LISTE_OFFRES_VOIR_DOCUMENTS: {
    categorie: 'Liste-Offres',
    action: 'Voir-Documents',
    nom: 'Liste-Offres-Voir-Documents-${rubrique}-${offre}',
  },
  LISTE_PROJETS_ACCEDER_FICHE_PROJET: {
    categorie: 'Liste-Projets',
    action: 'Acceder-Fiche-Projet',
    nom: 'Liste-Projets-Acceder-Fiche-Projet-${elementCliquable}',
  },
  LISTE_PROJETS_EXPORTER_TOUS_LES_PROJETS: {
    categorie: 'Liste-Projets',
    action: 'Exporter-Tous-Les-Projets',
    nom: 'Liste-Projets-Exporter-Tous-Les-Projets',
  },
  MENU_LATERAL_ACCEDER_ACCUEIL: {
    categorie: 'Menu-Lateral',
    action: 'Acceder-Accueil',
    nom: 'Menu-Lateral-Acceder-Accueil',
  },
  MENU_LATERAL_ACCEDER_CONVENTIONS_PARTENARIAT: {
    categorie: 'Menu-Lateral',
    action: 'Acceder-Conventions-Partenariat',
    nom: 'Menu-Lateral-Acceder-Conventions-Partenariat',
  },
  MENU_LATERAL_ACCEDER_LISTE_OFFRES: {
    categorie: 'Menu-Lateral',
    action: 'Acceder-Liste-Offres',
    nom: 'Menu-Lateral-Acceder-Liste-Offres-${rubrique}',
  },
  MENU_LATERAL_ACCEDER_NOUVEAUTES: {
    categorie: 'Menu-Lateral',
    action: 'Acceder-Nouveautes',
    nom: 'Menu-Lateral-Acceder-Nouveautes',
  },
  NAVIGATION_ACCEDER_PAGE: {
    categorie: 'Navigation',
    action: 'Acceder-Page',
    nom: 'Navigation-Acceder-Page-${page}',
  },
  REMUNERATIONS_ACCEDER_CONVENTIONS_PARTENARIAT: {
    categorie: 'Remunerations',
    action: 'Acceder-Conventions-Partenariat',
    nom: 'Remunerations-Acceder-Conventions-Partenariat',
  },
  REMUNERATIONS_ACCEDER_REMUNERATIONS_COMPLEMENTAIRES: {
    categorie: 'Remunerations',
    action: 'Acceder-Remunerations-Complementaires',
    nom: 'Remunerations-Acceder-Remunerations-Complementaires',
  },
  REMUNERATIONS_CLIQUER_BOUTON_BANDEAU: {
    categorie: 'Remunerations',
    action: 'Cliquer-Bouton-Bandeau',
    nom: 'Remunerations-Cliquer-Bouton-Bandeau-${libellé}',
  },
  REMUNERATIONS_TELECHARGER_ATTESTATION_FISCALE: {
    categorie: 'Remunerations',
    action: 'Telecharger-Attestation-Fiscale',
    nom: 'Remunerations-Telecharger-Attestation-Fiscale',
  },
  REMUNERATIONS_TELECHARGER_BORDEREAU: {
    categorie: 'Remunerations',
    action: 'Telecharger-Bordereau',
    nom: 'Remunerations-Telecharger-Bordereau-${onglet}-${portefeuille}-${format}',
  },
  REMUNERATIONS_TELECHARGER_GUIDE_REMUNERATION: {
    categorie: 'Remunerations',
    action: 'Telecharger-Guide-Remuneration',
    nom: 'Remunerations-Telecharger-Guide-Remuneration',
  },
  REMUNERATIONS_VOIR_PLUS_DE_BORDEREAUX: {
    categorie: 'Remunerations',
    action: 'Voir-Plus-De-Bordereaux',
    nom: 'Remunerations-Voir-Plus-De-Bordereaux',
  },
} as const satisfies MatomoEventMap;

export type MatomoEventKey = keyof typeof matomoEventMap;

export default matomoEventMap;
